import ConferenceCallInformationForm from '@templates/ConferenceCallInformationForm/ConferenceCallInformationForm';
import PropTypes from 'prop-types';
import { personType } from '@reducers/conference';

class CreateTranscriptForm extends ConferenceCallInformationForm {
  static propTypes = {
    addPerson: PropTypes.func.isRequired,
    callAudio: PropTypes.object,
    conferenceCallUuid: PropTypes.string,
    date: PropTypes.string.isRequired,
    errors: PropTypes.shape({
      title: PropTypes.string,
    }),
    people: PropTypes.arrayOf(personType),
    setCallAudio: PropTypes.func.isRequired,
    setPersonField: PropTypes.func.isRequired,
    title: PropTypes.string,
    token: PropTypes.string.isRequired,
    setField: PropTypes.func.isRequired,
    tags: PropTypes.arrayOf(PropTypes.string).isRequired,
    addTag: PropTypes.func.isRequired,
    deleteTag: PropTypes.func.isRequired,
    conferenceHasBeenFinished: PropTypes.bool,
    userId: PropTypes.number,
    organizationId: PropTypes.string,
    organization: PropTypes.object,
    organizationsList: PropTypes.array.isRequired,
    numbersByCountries: PropTypes.array.isRequired,
  };

  static defaultProps = {
    title: '',
    conferenceHasBeenFinished: true,
  };
}

export default CreateTranscriptForm;



// WEBPACK FOOTER //
// ./components/templates/CreateTranscriptForm/CreateTranscriptForm.js